import React from "react";
import PersonIcon from "@material-ui/icons/Person";
import { useTranslation } from "react-i18next";
import { BoxButton } from "shared";
import { Link } from "react-router-dom";
import { Area } from "types";

const CareEventConfigurations: React.VFC = () => {
  const { t } = useTranslation();

  return (
    <BoxButton startIcon={<PersonIcon />} component={Link} to={Area.CareEventConfigurations}>
      {t("care_event_configurations.label")}
    </BoxButton>
  );
};

export default CareEventConfigurations;
